export default __webpack_public_path__ + "static/media/team-john.046728e9.jpg";